import { Column } from "@faire/web/slate/Layout";
import { Spacer } from "@faire/web/slate/spacing";
import { Typography } from "@faire/web/slate/Typography";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import { Bold } from "../common/Bold";
import { LiItem } from "../common/LiItem";
export var FailedDeliveryAttempt = function FailedDeliveryAttempt() {
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ObOGqM",
    defaultMessage: [{
      "type": 0,
      "value": "Wanneer een afleverpoging mislukt, is het belangrijk om snel te handelen om de situatie aan te pakken en ervoor te zorgen dat je zending de verkoper met succes bereikt. Dit is wat je kunt doen:"
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ol", null, /*#__PURE__*/React.createElement(LiItem, {
    step: 1
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "Dk6+pO",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Neem contact op met de vervoerder:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " neem onmiddellijk contact op met de vervoerder om de reden van de mislukte bezorgpoging te achterhalen en de mogelijkheid te bespreken om de bezorging opnieuw te proberen."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 2
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "fHRo9Q",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Stuur je retailer een bericht:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " breng de retailer op de hoogte van de mislukte bezorgpoging en eventuele updates of wijzigingen die van invloed kunnen zijn op de levertijd."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 3
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "v4mWlX",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Controleer het verzendadres:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " controleer nogmaals het verzendadres dat door de retailer is opgegeven. Als er verschillen zijn, bevestig dan het juiste adres bij de retailer."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(LiItem, {
    step: 4
  }, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "/2TRVS",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "Regel een nieuwe levering:"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": " zodra het adres is bevestigd en eventuele problemen zijn opgelost, overleg dan met de vervoerder om zo snel mogelijk een nieuwe levering te plannen."
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};